import React from 'react'
import { Route } from 'react-router-dom'
import CLIENT_ENDPOINTS from '../../../constants/client-endpoints'
import LearningResourcesScreen from '../screen'
import LearningResourceRoutes from '../../learning-resource/routes'

const LearningResourcesRoutes = () => {
    return (
        <React.Fragment>
            <Route path={CLIENT_ENDPOINTS.LEARNING_RESOURCES} component={LearningResourcesScreen} />
            <LearningResourceRoutes />
        </React.Fragment>
    )
}

export default LearningResourcesRoutes